import React, { useEffect, useRef, useState } from 'react'
import { FormControl, InputLabel, makeStyles, MenuItem, Select, TextField } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import { ListGroup, Button, Alert, ProgressBar } from 'react-bootstrap'
import './GalleryAdd.css'
import { GalleryAddPreview } from './GalleryAddPreview'
import api from '../../services/api'
import * as actions from './_redux/IconsActions'
import { useDispatch } from 'react-redux'
import * as GalleryUIHelper from './GalleryUIHelper'
import { getUserAccessLevel } from "../../../app/helpers/role";
import _ from 'lodash';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

export function GalleryAdd ({ onReload }) {
    const classes = useStyles();
    
    // Ref
    const fileInputRef = useRef();
    // State
    
    const [selectedFilesNames, setSelectedFilesNames] = useState([])
    const [selectedFilesTypes, setSelectedFilesTypes] = useState([])
    const [selectedFiles, setSelectedFiles] = useState([])
    const [validFiles, setValidFiles] = useState([])
    const [unsupportedFiles, setUnsupportedFiles] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [progressNumber, setProgressNumber] = useState(0);
    const userAcessLevel = getUserAccessLevel(); 

    // Redux state
    const dispatch = useDispatch();

    // useEffect
    useEffect(() => {
        console.log(selectedFiles);
        let filteredArr = selectedFiles.reduce((acc, current) => {
            const x = acc.find(item => item.name === current.name);
            if (!x) {
              return acc.concat([current]);
            } else {
              return acc;
            }
        }, []);
        setValidFiles([...filteredArr]);
    }, [selectedFiles]);

    //
    //
    //
    const fileInputClicked = () => {
        fileInputRef.current.click();
    }

    //
    // Drag events
    //
    const preventDefault = (e) => {
        e.preventDefault();
    }

    const dragOver = (e) => {
        preventDefault(e);
    }

    const dragEnter = (e) => {
        preventDefault(e);
    }

    const dragLeave = (e) => {
        preventDefault(e);
    }

    const fileDrop = (e) => {
        preventDefault(e);
        const files = e.dataTransfer.files;
        if (files.length) {
            handleFiles(files);
        }
    }
    //
    //
    //
    const validateFile = (file) => {
        return _.includes(GalleryUIHelper.validImageTypes, file.type);
    }

    //
    // File
    //
    const filesSelected = () => {
        if (fileInputRef.current.files.length) {
            handleFiles(fileInputRef.current.files);
        }
    }

    const handleFiles = (files) => {
        for(let i = 0; i < files.length; i++) {
            const name = files[i].name;
            if (validateFile(files[i])) {
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
            } else {
                files[i]['invalid'] = true;
                setSelectedFiles(prevArray => [...prevArray, files[i]]);
                setErrorMessage('File type not permitted');
                setUnsupportedFiles(prevArray => [...prevArray, files[i]]);
            }
            setSelectedFilesNames((oldValue) => {
                return {
                    ...oldValue,
                    [name]: name
                }
            });
            setSelectedFilesTypes((oldValue) => {
                return {
                    ...oldValue,
                    [name]: 0,
                }
            });
        }
    }

    const uploadFiles = () => {
        for (let i = 0; i < validFiles.length; i++) {
            var file = validFiles[i];
            var formData = new FormData();
            // Pega o nome do arquivo
            const name = file.name;

            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: function (progressEvent) {
                    let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    setProgressNumber(percentCompleted);
                }
            }

            // Prepara o form para envio
            formData.append(name.toLowerCase(), file);
            api.post('standard/uploadFiles', formData, config)
            .then( (response) => {
                setProgressNumber(0);
                if ( response.status === 200 ) {
                    dispatch(actions.createIcon({
                        name: selectedFilesNames[name],
                        type: selectedFilesTypes[name],
                        photo: response.data[name.toLowerCase()]
                    })).then(() => {
                        removeFile(validFiles.name)
                        onReload && onReload()
                    }).catch(() => {
                        console.log('A')
                    });
                }
            }).catch( (error) => {
                setErrorMessage(error);
            });
        }
    }

    const removeFile = (name) => {
        const index = validFiles.findIndex(e => e.name === name);
        const index2 = selectedFiles.findIndex(e => e.name === name);
        const index3 = unsupportedFiles.findIndex(e => e.name === name);
        
        validFiles.splice(index, 1);
        selectedFiles.splice(index2, 1);
        
        setValidFiles([...validFiles]);
        setSelectedFiles([...selectedFiles]);
        if (index3 !== -1) {
            unsupportedFiles.splice(index3, 1);
            setUnsupportedFiles([...unsupportedFiles]);
        }
    }

    const handleChangeName = ( event ) => {
        const name = event.target.name
        const value = event.target.value
        setSelectedFilesNames({
            ...selectedFilesNames,
            [name]: value
        })
    }

    const handleChangeType = ( event ) => {
        const name = event.target.name
        const value = event.target.value
        setSelectedFilesTypes({
            ...selectedFilesTypes,
            [name]: value
        })
    }

    return (
        <>
            <div className="mb-4">
 
                {userAcessLevel >= 2 &&
                <div className="row">
                    <div className="col-12">
                        <div className="drop-container mb-4"
                            onDragOver={dragOver}
                            onDragEnter={dragEnter}
                            onDragLeave={dragLeave}
                            onDrop={fileDrop}
                            onClick={fileInputClicked}
                            >
                            <div className="drop-message">
                                <div className="upload-icon"></div>
                                Arraste e solte arquivos aqui ou clique para selecionar arquivo(s)
                            </div>
                            <input
                                ref={fileInputRef}
                                className="file-input"
                                accept={GalleryUIHelper.validImageTypes}
                                type="file"
                                multiple
                                onChange={filesSelected}
                                />
                        </div>
                    </div>
                </div>
                }        
                <div>
                    {unsupportedFiles.length === 0 && validFiles.length ? (
                        <Button variant="outline-info" className="mb-4" onClick={() => uploadFiles()}>Cadastrar</Button>
                    ) : ''}
                    {unsupportedFiles.length ? (
                        <Alert variant="danger" className="mb-4">
                            Remova todos os arquivos não suportados.
                        </Alert>
                    ) : ''}
                </div>

                <div className="row">
                    <div className="col-12">
                        <ListGroup>
                            {
                                validFiles.map((data, i) => 
                                    <ListGroup.Item 
                                        key={i + '-' + data.name} 
                                        variant={data.invalid ? 'danger' : ''}
                                    >
                                        <div className="row">
                                            <span className="col-12 col-md-4">
                                                <GalleryAddPreview data={data} />
                                            </span>
                                            <span className="col-5 col-md-3 col-sm-6">
                                                <FormControl>
                                                    <InputLabel htmlFor="type-simple">Tipo</InputLabel>
                                                    <Select
                                                        value={selectedFilesTypes[data.name]}
                                                        onChange={handleChangeType}
                                                        className={classes.formControl}
                                                        inputProps={{
                                                            name: data.name,
                                                            id: 'type-simple',
                                                        }}
                                                    >
                                                        { GalleryUIHelper.IMAGE_TYPE.map((el) => <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>) }
                                                    </Select>
                                                </FormControl>
                                            </span>
                                            <span className="col-5 col-md-3 col-sm-6">
                                                <TextField
                                                    id={i + '-' + data.name}
                                                    label="Nome"
                                                    className={classes.formControl}
                                                    name={data.name}
                                                    defaultValue={data.name}
                                                    onChange={handleChangeName}
                                                />
                                            </span>
                                            <span className="col-2">
                                                <Button 
                                                    variant="danger"
                                                    onClick={() => removeFile(data.name)}
                                                >
                                                    <DeleteIcon />
                                                </Button>
                                            </span>
                                        </div>
                                    </ListGroup.Item>
                                )
                            }
                        </ListGroup>
                        {
                            progressNumber !== 0 &&
                            <ProgressBar className={'w-100 d-block'} style={{ height: '30px' }} now={progressNumber} variant="success"
                                label={`${progressNumber}%`} />
                        }
                    </div>
                </div>
            </div>
        </>
    )
}